import Button from "@8x8/oxygen-button";
import ErrorIcon from "@8x8/oxygen-icon/novo/ErrorIcon";
import { Spinner } from "@8x8/oxygen-loaders";
import Tooltip, { orientation, showOn } from "@8x8/oxygen-tooltip";

import {
  CenteredText,
  PartialDataContainer,
  PartialDataInnerContainer,
} from "./styled";

const TablePartialDataIndicator = (props) => {
  const { onAbort } = props;
  return (
    <PartialDataContainer>
      <Tooltip
        orientation={orientation.top}
        showOn={showOn.hover}
        title={
          <CenteredText>
            Displaying partial results.
            <br />
            Loading additional data...
            <br />
            Click to cancel.
          </CenteredText>
        }
      >
        <Button variant={"tertiaryReversed"} onClick={(event) => onAbort()}>
          <PartialDataInnerContainer>
            <ErrorIcon color="orange" />
            <Spinner size={"small"} />
          </PartialDataInnerContainer>
        </Button>
      </Tooltip>
    </PartialDataContainer>
  );
};

export default TablePartialDataIndicator;
